import { render, staticRenderFns } from "./PrivacyPolicyView.vue?vue&type=template&id=4530f014&scoped=true&"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyView.vue?vue&type=style&index=0&id=4530f014&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4530f014",
  null
  
)

export default component.exports